/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

function AutoCompleete() {
  if (!this instanceof AutoCompleete) return new AutoCompleete();

  var that = this;

  //create node in root of document
  this._node = document.createElement("ul");
  this._node.classList.add("autocompleete");
  document.body.appendChild(this._node);

  this._currentTarget = null;

  this.use = use;
  this._position = position;

  document.addEventListener("scroll", position, {
    capture: true, //trigger this when anything is scrolled
    passive: true, //increese slightly the scroll performance
  });
  document.addEventListener("resize", position);

  document.body.addEventListener(
    "click",
    function (e) {
      if (!that._currentTarget) return;

      var target = e.target;
      while (target !== document.body) {
        if (target.classList.contains("autocompleete")) return;
        target = target.parentNode;
      }

      //if not returned, stop propagination and hide
      e.stopImmediatePropagation();
      e.stopPropagation();

      hide();
    },
    {
      capture: true,
    }
  );

  /**
   * Show the autocompleete widget.
   * @param {Element} target
   * @param {Array<Object>} values
   * If no <i>key</i> specified, make sure there is a <i>name</i> attribute on each object
   * @param {function} cb
   * Callback with an item from <i>values</i>
   * @param {string} key
   * Optional attribute key for displaying the results.
   * @returns {undefined}
   */
  function use(target, values, cb, key) {
    key = key || "name";

    that._currentTarget = target;

    empty();

    //create list
    for (let i = 0, len = values.length; i < len; i++) {
      let val = values[i];

      var li = document.createElement("li");
      li.textContent = val[key];
      li.addEventListener("click", function () {
        hide();

        //callback with value
        cb(val);
      });
      that._node.appendChild(li);
    }

    //show list
    that._node.classList.add("active");

    //set position
    position();
  }

  function empty() {
    var node = that._node;
    while (node.firstChild) node.removeChild(node.firstChild);
  }

  function hide() {
    //hide list
    that._node.classList.remove("active");

    //empty list
    empty();

    that._currentTarget = null;
  }

  function position() {
    if (!that._node.classList.contains("active")) return;

    var rect = that._currentTarget.getBoundingClientRect();
    that._node.style.top = rect.top + rect.height + "px";
    that._node.style.left = rect.left + "px";
  }
}
